module.exports = "<ng-container>\n    <div #nearbystoremap class=\"maps\"></div>\n</ng-container>"